// test1288
(1288 && 0);
